import { CalculationEngineMonthlyValueOverrides, FarmerMarginCalculatorModel, RunCalculationEngineResponse } from '../../../../../Generated/Raven-Demeter';
import { TrackingEvent } from '../../../../Services/Tracking/TrackingService';
import { DemeterCalculationEngineLineShortModelWithChildren, HideGroup, MarginCompositeModel } from '../../RiskDefinitions';
import styles from './MarginInputsTable.module.scss';
import MarginInputsTableStickyColumn from './MarginInputsTableStickyColumn';
import MarginInputTableData from './MarketInputsTableData/MarginInputsTableData';

interface IMarginInputsTableProps {
    getFarmerMarginCalculatorCompositeRowsModel: MarginCompositeModel[];
    runCalculationEngineResponse: RunCalculationEngineResponse;
    runMonthlyValueOverrides: Array<CalculationEngineMonthlyValueOverrides> | null;
    savedFarmerMarginCalculator?: FarmerMarginCalculatorModel;
    hideGroup: HideGroup;
    hideRows: string[];
    setHideGroup: (hideGroup: HideGroup) => void;
    quarterOptions: { label: string; value: { quarter: number; year: number } }[];
    setRunMonthlyValueOverrides: (runMonthlyValueOverrides: Array<CalculationEngineMonthlyValueOverrides> | null) => void;
    handleRemoveLotLineRow: (row: DemeterCalculationEngineLineShortModelWithChildren) => void;
    track: TrackingEvent;
}

const MarginInputsTable: React.FC<IMarginInputsTableProps> = (props: IMarginInputsTableProps) => (
    <div className={styles.margin_inputs_table}>
        <MarginInputsTableStickyColumn
            getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
            hideGroup={props.hideGroup}
            hideRows={props.hideRows}
            setHideGroup={props.setHideGroup}
        />
        <MarginInputTableData
            getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
            runCalculationEngineResponse={props.runCalculationEngineResponse}
            quarterOptions={props.quarterOptions}
            hideGroup={props.hideGroup}
            hideRows={props.hideRows}
            runMonthlyValueOverrides={props.runMonthlyValueOverrides}
            setRunMonthlyValueOverrides={props.setRunMonthlyValueOverrides}
            savedFarmerMarginCalculator={props.savedFarmerMarginCalculator}
            handleRemoveLotLineRow={props.handleRemoveLotLineRow}
            track={props.track}
        />
    </div>
);

export default MarginInputsTable;
